var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"prelogin-container"},[_c('el-image',{staticClass:"prelogin-container__background-img",attrs:{"src":require('@/assets/images/background_preLogin.png')}}),_c('el-main',{staticClass:"prelogin-main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }